document.addEventListener('DOMContentLoaded', function() {
  const articles = document.querySelectorAll('.article-group');

  const groupedArticles = {};
  articles.forEach(function(article) {
    const tags = article.dataset.tags.split(',');
    const tagTitle = tags.map(tag => tag.replace(/-/g, ' ')).join(', ');

    if (!groupedArticles[tagTitle]) {
      groupedArticles[tagTitle] = [];
    }
    groupedArticles[tagTitle].push(article);
  });

  // Filter tags with less than three articles
  const filteredTags = Object.keys(groupedArticles).filter(tagTitle => groupedArticles[tagTitle].length >= 3);

  // Sort tags alphabetically
  const sortedTags = filteredTags.sort();

  const container = document.querySelector('.tag-container');
  sortedTags.forEach(tagTitle => {
    const tagSection = document.createElement('section');
    tagSection.classList.add('tag-section');

    // Add data-tag-count attribute to the tag section
    tagSection.setAttribute('data-tag-count', groupedArticles[tagTitle].length);

    const tagHeading = document.createElement('h2');
    tagHeading.textContent = tagTitle;
    tagSection.appendChild(tagHeading);

    const viewAllLink = document.createElement('a');
    viewAllLink.href = "/blogs/tutorials/tagged/" + tagTitle.replace(/ /g, "-");
    viewAllLink.textContent = "View All";
    viewAllLink.classList.add('article-tag-link'); // Add the "article-tag-link" class to the link
    tagSection.appendChild(viewAllLink);

    const tagArticles = document.createElement('div');
    tagArticles.classList.add('tag-articles');
    const articlesToShow = groupedArticles[tagTitle];

    for (let i = 0; i < Math.min(articlesToShow.length, 3); i++) {
      const article = articlesToShow[i];
      const tagArticle = document.createElement('div');
      tagArticle.classList.add('tag-article');

      const articleLink = document.createElement('a');
      articleLink.href = article.querySelector('.article-link a').href;

      const articleImage = document.createElement('div');
      articleImage.classList.add('article-image');
      articleImage.innerHTML = article.querySelector('.article-image').outerHTML;
      articleLink.appendChild(articleImage);

      const articleTitle = document.createElement('h3');
      articleTitle.classList.add('article-title');
      articleTitle.textContent = article.querySelector('.article-title').textContent;
      articleLink.appendChild(articleTitle);

      tagArticle.appendChild(articleLink);

      const articleMeta = document.createElement('div');
      articleMeta.classList.add('article-meta');
      const authorSpan = document.createElement('span');
      authorSpan.classList.add('article-author');
      authorSpan.textContent = article.querySelector('.article-author').textContent;
      articleMeta.appendChild(authorSpan);
      const publishedSpan = document.createElement('span');
      publishedSpan.classList.add('article-published');
      publishedSpan.textContent = article.querySelector('.article-published').textContent;
      articleMeta.appendChild(publishedSpan);
      tagArticle.appendChild(articleMeta);

      tagArticles.appendChild(tagArticle);
    }

    tagSection.appendChild(tagArticles);
    container.appendChild(tagSection);
  });
});

// Function to truncate text to a specified word count
function truncateText(text, wordCount) {
  const words = text.split(' ');
  if (words.length > wordCount) {
    return words.slice(0, wordCount).join(' ') + '...';
  } else {
    return text;
  }
}